import { combineReducers } from 'redux';
import profile from './profileReducers';
import location from './locationReducers';
import other from './otherReducers';
import notif from './notifReducer';
import ingredientLib from './ingredientLibrary';
import menu from './menu';
import roleAccess from './roleAccess';
import registration from './registration';

const rootReducer = combineReducers({
  profile,
  location,
  other,
  notif,
  ingredientLib,
  menu,
  roleAccess,
  registration,
});

export default rootReducer;
